import { getAxiosInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Withdraw routes
 * ----------------------------
 */
export const getWithdraw = (query, force = false, callback) => {
    cachiosInstance.get(`/withdraw?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getSingleWithdraw = (withdrawId, callback) => {
    cachiosInstance.get(`/withdraw/${withdrawId}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const updateWithdraw = (withdrawId, query, callback) => {
    getAxiosInstanceApi().put(`/withdraw/${withdrawId}?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};